document.addEventListener('DOMContentLoaded', () => {
  const STORAGE_KEY = 'eltagg-wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch(e) {
      return [];
    }
  }

  function setWishlist(arr) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
  }

  function toggleWishlist(handle) {
    let list = getWishlist();
    if (list.includes(handle)) {
      list = list.filter(item => item !== handle);
    } else {
      list.push(handle);
    }
    setWishlist(list);
    syncButtons();
  }

  function syncButtons() {
    const list = getWishlist();
    const buttons = document.querySelectorAll('.wishlist-btn');
    buttons.forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      if (list.includes(handle)) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  }

  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('.wishlist-btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation(); // prevent navigating to product if inside a link
      const handle = btn.getAttribute('data-product-handle');
      if (handle) {
        toggleWishlist(handle);
      }
    }
  });

  // Initial sync
  syncButtons();
});
